import './Table.scss';
import { useState } from "react";
import { sortBy } from "../../../utils/sort";

const Table = ({editable, header, fields, items, onEditRowClick, onDeleteRowClick}) => {
    const [sortHeader, setSortHeader] = useState();
    const [reverseOrder, setReverseOrder] = useState(false);

    const toggleHeader = (header) => {
        if (sortHeader === header) {
            setReverseOrder(!reverseOrder);
            return;
        }
        setSortHeader(header);
    }
    const getHeaderSortState = () => {
        if (reverseOrder) {
            return 'reverse';
        }
        return 'normal';
    }
    const renderHeader = (header) => (
        <thead className="table-component__header">
        <tr>
            {header.map((el, idx) => (
                <th
                    key={`table-header-${idx}`}
                    className="table-column"
                    onClick={() => toggleHeader(fields[idx])}
                >
                    <span>
                        {el}
                        {sortHeader === fields[idx] && (
                            <span
                                className={`table-component__column-sort table-component__column-sort--${getHeaderSortState()}`}/>
                        )}
                    </span>

                </th>
            ))}
        </tr>
        </thead>
    );

    const renderRows = (items, fields) => sortBy(items, sortHeader, reverseOrder)
        .map((el, idx) => (
            <tr key={`table-row-${idx}`} className="table-component__row">
                {fields.map((field, idx) => (
                    <td key={`table-column-${idx}`} className="table-column">
                        <span>{el[field]}</span>
                    </td>
                ))}
                {editable && (
                    <td key={`table-column-${idx}`} className="table-column table-column--edit-buttons">
                        <div className="edit-button edit-button--edit" onClick={() => onEditRowClick(el)}/>
                        <div className="edit-button edit-button--delete" onClick={() => onDeleteRowClick(el)}/>
                    </td>
                )}
            </tr>
        ));

    return (
        <table className="table-component">
            {renderHeader(header)}
            <tbody>
            {renderRows(items, fields)}
            </tbody>
        </table>
    );
}

export default Table;